import { render } from "./created.vue?vue&type=template&id=1ba5ae7f"
import script from "./created.vue?vue&type=script&lang=js"
export * from "./created.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__